<div class="block justify-between page-header md:flex">
  <div class="page-title">
    <h3
      class="!text-defaulttextcolor dark:!text-defaulttextcolor/70 dark:text-white dark:hover:text-white !text-[1.125rem] font-semibold">
      {{title}}
    </h3>
  </div>
  <ol *ngIf="breadcrumbs.length > 0" class="flex items-center whitespace-nowrap min-w-0">
    <!-- Breadcrumbs -->
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last" class="text-[0.813rem] ps-[0.5rem]">
      <a *ngIf="!breadcrumb.isActive && breadcrumb.isClickable" 
         (click)="goToBreadcrumb(breadcrumb.url); $event.preventDefault()"
         class="flex items-center text-primary hover:text-primary/80 dark:text-primary dark:hover:text-primary/80 truncate cursor-pointer transition-colors"
         role="button"
         tabindex="0"
         [title]="breadcrumb.title">
        {{ breadcrumb.title }}
        <i *ngIf="!last"
          class="ri-arrow-right-s-line flex-shrink-0 text-[#8c9097] dark:text-white/50 px-[0.5rem] overflow-visible rtl:rotate-180 text-[0.875rem]"></i>
      </a>
      <span *ngIf="breadcrumb.isActive || !breadcrumb.isClickable"
        [ngClass]="{'flex items-center text-black dark:text-white font-semibold': breadcrumb.isActive, 'flex items-center text-defaulttextcolor dark:text-white/70 font-semibold': !breadcrumb.isActive}">
        {{ breadcrumb.title }}
        <i *ngIf="!last"
          class="ri-arrow-right-s-line flex-shrink-0 text-[#8c9097] dark:text-white/50 px-[0.5rem] overflow-visible rtl:rotate-180 text-[0.875rem]"></i>
      </span>
    </li>
  </ol>
</div>


